import { Injectable } from '@angular/core';
import {
  FieldAgentClient, WebTrackUser, CheckoutParameters,
  BisTrackSettingsAutomaticallyApplyWebTrackSalesOrders, CheckoutParametersOrderSource,
  CheckoutParametersSaleType, CheckoutParametersTransactionType, BasketHeader,
  ProductBasketLine, PromotionCodeDetail, CheckoutResults, CheckoutRequest,
  BisTrackSettings, CheckoutParametersAutoApplySO, BasketLineSuper,
  BasketLineSuperBasketLineType, EmailTemplate,
  ConfirmationEmailRequest, UserOption, UserOptionOptionType, PaymentRequestEmailParameters,
  Computer, ReportParameters, ReportParametersReportType,
  ReportParametersDocumentType, DocumentType2, ReportServerQueueItem,
  ReportServerQueueItemType, ReportServerQueueItemStatus, ReportServerQueueItemDocumentType,
  I4goTrueTokenParamsResponse, WebTrackPaymentTokenPaymentProvider,
  WebServiceCallResult, Order, MakePaymentOnOrderRequest, MakePreauthorizedPaymentRequest,
  WebSvcCallResult_WebTrackPaymentResult_PaymentFailure, PaymentFailureReasonCode, Shift4WebTrackPaymentToken,
  VoidPaymentRequest, CreAvsRequest, EpicorPaymentTokenRequest, EpicorPaymentCheckAVSRequest, CustomerCard
} from 'ep-bt-field-agent-proxy';
import { UserOptionsID, ContentServiceEmailTemplateType, SendPaymentLinkResult, ResponseCode, SaleType } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../services/epbt-field-agent.service';
import { EpbtFaQuickOrderService } from '../services/epbt-fa-quick-order.service';
import { EpbtFaShoppingCartModel } from '../models/epbt-fa-shopping-cart-model';
import { EpbtFaReturnParametersModel } from '../models/epbt-fa-return-parameters-model';
import { EpDialogService, IEpDialogResult, IEpDialogOptions, EpDialogButtons } from '@epicor/kinetic';

@Injectable({
  providedIn: 'root'
})

export class EpbtFaQuickOrderSummaryService {

  public isQuickOrder: boolean;

  public bisTrackSettings: BisTrackSettings;
  public webTrackUser: WebTrackUser;
  public emailTemplate: EmailTemplate;
  public i4goTrueTokenParameters: I4goTrueTokenParamsResponse;
  public paymentUrl: string;
  public emailButtonFlag = false;

  public waitFlag = false;
  public errorFlag = false;
  public successFlag = false;
  public cardVerificationFlag = false;

  public successMessageLiteral: string;
  public successTimestampLiteral: string;
  public successAmountLiteral: number;
  public successCardNumber: string;
  public successCardType: string;
  public successConfirmationCode: string;
  public successTransactionId: string;

  public cardHolderName = '';
  public streetAddress = '';
  public postalCode = '';

  public orderTotalAmount = 0;
  public orderTotalTax = 0;
  public selectedOrder: Order;

  constructor(private client: FieldAgentClient, private faService: EpbtFieldAgentService, private quickOrderService: EpbtFaQuickOrderService) {
    this.faService.getBisTrackSetting((bisTrackSettings: any) => {
      this.bisTrackSettings = bisTrackSettings;
    });

    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });
  }

  generateWebTrackOrder(subscribe: (checkoutResult: any) => void) {

    const parameters: CheckoutParameters = new CheckoutParameters();
    parameters.webTrackInstanceID = this.bisTrackSettings.webTrackInstanceID;
    parameters.transactionType = this.quickOrderService.quickOrder.TransactionType == 2 ? CheckoutParametersTransactionType.Quote : CheckoutParametersTransactionType.Order;
    parameters.autoProcess = this.bisTrackSettings.automaticallyApplyWebTrackSalesOrders > BisTrackSettingsAutomaticallyApplyWebTrackSalesOrders.No;
    if (this.bisTrackSettings.automaticallyApplyWebTrackSalesOrders == BisTrackSettingsAutomaticallyApplyWebTrackSalesOrders.YesPark) {
      parameters.autoApplySO = CheckoutParametersAutoApplySO.YesPark;
    } else if (this.bisTrackSettings.automaticallyApplyWebTrackSalesOrders == BisTrackSettingsAutomaticallyApplyWebTrackSalesOrders.YesComplete) {
      parameters.autoApplySO = CheckoutParametersAutoApplySO.YesComplete;
    } else {
      parameters.autoApplySO = CheckoutParametersAutoApplySO.No;
    }
    const webTrackUser = this.webTrackUser;
    webTrackUser.customer = this.quickOrderService.quickOrder.customer;
    parameters.user = webTrackUser;
    parameters.orderSource = CheckoutParametersOrderSource.Cloud;

    if (this.quickOrderService.quickOrder.selectedSalesType == 1) {
      parameters.saleType = CheckoutParametersSaleType.CollectNow;
    } else if (this.quickOrderService.quickOrder.selectedSalesType == 2) {
      parameters.saleType = CheckoutParametersSaleType.CollectLater;
    } else if (this.quickOrderService.quickOrder.selectedSalesType == 3) {
      parameters.saleType = CheckoutParametersSaleType.Delivered;
    }

    parameters.dateRequired = this.quickOrderService.quickOrder.dateRequired;

    //Below line is to reset time to 0
    parameters.dateRequired.setUTCHours(0, 0, 0, 0);
    parameters.specialInstructions = this.quickOrderService.quickOrder.specialInstructions ? this.quickOrderService.quickOrder.specialInstructions.toString() : '';
    parameters.deliveryAddress = this.quickOrderService.quickOrder.deliveryAddress;
    // if (!parameters.deliveryAddress.province)
    //   parameters.deliveryAddress.province = new Province();
    parameters.contactName = this.quickOrderService.quickOrder.contact.name;
    parameters.contactTelephone = this.quickOrderService.quickOrder.contact.telephone;
    parameters.notificationEmailAddress = this.quickOrderService.quickOrder.contact.email;
    parameters.orderReference = this.quickOrderService.quickOrder.customerRef;
    parameters.useThisCustomer = this.quickOrderService.quickOrder.customer;
    parameters.tradingBranchId = this.quickOrderService.quickOrder.branch.branchID;

    parameters.orderID = this.quickOrderService.quickOrder.OrderID;
    parameters.orderNumber = this.quickOrderService.quickOrder.OrderNumber.toString();

    // do we have a payment?
    if (this.quickOrderService.quickOrder.PaymentResult != null) {
      // PaymentGateway.Shift4.PaymentGateway.InitializeCheckoutParameters(parameters, null, Sess.Current.QuickOrder.PaymentResult, null);
    }

    if (this.quickOrderService.quickOrder.taxArea != null) {
      parameters.taxAreaID = this.quickOrderService.quickOrder.taxArea.taxAreaID;
    }

    const basketHeader: BasketHeader = new BasketHeader();
    basketHeader.basketId = 0;
    basketHeader.userId = 0;
    basketHeader.basketReference = '';
    basketHeader.dateTimeCreated = new Date();
    basketHeader.dateTimeLastModified = basketHeader.dateTimeCreated;
    const basketLineSupers: BasketLineSuper[] = [];

    this.quickOrderService.quickOrder.Lines.forEach(orderLine => {

      const productBasketLine: ProductBasketLine = new ProductBasketLine();
      productBasketLine.product = orderLine.Product;
      productBasketLine.manualOrderLineTypeID = orderLine.Product.manualOrderLineTypeID;
      productBasketLine.manualDescription = orderLine.ManualDescription;
      productBasketLine.unitCost = orderLine.UnitCostPrice;
      productBasketLine.sellPer = orderLine.Per;
      productBasketLine.inputPer = orderLine.InputPer;
      productBasketLine.quantity = Math.round(Number(Number(orderLine.Quantity).toFixed(4))); // Math.round(Number(orderLine.Quantity.toFixed(4)));
      productBasketLine.quantityTally = orderLine.QuantityTally;
      productBasketLine.unitSellPrice = orderLine.UnitSellPrice;
      productBasketLine.totalSellPrice = orderLine.TotalSellPrice;
      productBasketLine.noCustomerPricing = false;
      productBasketLine.customerRef = '';
      productBasketLine.inSection = false;
      productBasketLine.specialProductDescription = orderLine.SpecialProductDescription;
      productBasketLine.specialProductCode = '';
      productBasketLine.totalTax = orderLine.TotalTax;
      productBasketLine.discount1 = orderLine.Discount1;
      productBasketLine.discount2 = orderLine.Discount2;
      productBasketLine.lineNotes = orderLine.LineNotes;

      const basketLineSuper: BasketLineSuper = new BasketLineSuper();
      basketLineSuper.basketLineType = BasketLineSuperBasketLineType.ProductBasketLine;
      basketLineSuper.productBasketLine = productBasketLine;

      basketLineSupers.push(basketLineSuper);
    });

    const promotionCodeDetail: PromotionCodeDetail[] = [];
    let checkoutResult: CheckoutResults;

    const checkoutRequest: CheckoutRequest = new CheckoutRequest();
    checkoutRequest.parameters = parameters;
    checkoutRequest.basketHeader = basketHeader;
    checkoutRequest.basketLineSupers = basketLineSupers;
    checkoutRequest.promotionCodeDetail = promotionCodeDetail;

    this.client.checkout(checkoutRequest).subscribe(checkoutResult => {
      checkoutResult = checkoutResult;

      const transactionType = this.quickOrderService.quickOrder.TransactionType == 2 ? CheckoutParametersTransactionType.Quote : CheckoutParametersTransactionType.Order;

      if (transactionType == CheckoutParametersTransactionType.Order || transactionType == CheckoutParametersTransactionType.Quote) {
        this.quickOrderService.quickOrder.currentCart = this.populateShoppingCart(basketHeader, basketLineSupers);

        if (parameters.notificationEmailAddress) {
          const confirmationEmailRequest: ConfirmationEmailRequest = new ConfirmationEmailRequest();
          confirmationEmailRequest.checkoutParameters = parameters;
          confirmationEmailRequest.checkoutResults = checkoutResult;
          confirmationEmailRequest.bisTrackSettings = this.bisTrackSettings;
          // confirmationEmailRequest.transactionType =
          // this.quickOrderService.quickOrder.TransactionType == 2 ? SendConfirmationEmailRequestTransactionType.Quote : SendConfirmationEmailRequestTransactionType.Order;
          confirmationEmailRequest.fromEmail = parameters.notificationEmailAddress;
          // confirmationEmailRequest.basketHeader = basketHeader;
          // confirmationEmailRequest.basketLines = basketLineSupers;
          confirmationEmailRequest.checkoutRequest = checkoutRequest;

          this.sendConfirmation(confirmationEmailRequest, (flag: boolean) => {
            console.log('Send Confirmation', flag);
            subscribe(checkoutResult);
          });
          subscribe(checkoutResult);
        } else {
          subscribe(checkoutResult);
        }
      }
    });
  }

  populateShoppingCart(basketHeader: BasketHeader, basketLineSupers: BasketLineSuper[]): EpbtFaShoppingCartModel {
    const cart: EpbtFaShoppingCartModel = new EpbtFaShoppingCartModel(this.webTrackUser, this.bisTrackSettings);
    cart.header.basketId = basketHeader.basketId;
    cart.header.userId = basketHeader.userId;
    cart.header.basketReference = basketHeader.basketReference;
    cart.header.dateTimeCreated = basketHeader.dateTimeCreated;
    cart.header.dateTimeLastModified = basketHeader.dateTimeLastModified;
    cart.contents = basketLineSupers;
    return cart;
  }

  sendConfirmation(confirmationEmailRequest: ConfirmationEmailRequest, subscribe: (result: any) => void) {

    this.client.sendConfirmation(confirmationEmailRequest).subscribe(result => {
      subscribe(result);
    });

    // if (checkOutParameters.notificationEmailAddress) {

    // Below code is not use in legacy application

    // var emailTemplate: EmailTemplate;

    // if (transactionType == CheckoutParametersTransactionType.Order) {
    //   this.client.getEmailTemplate(EmailTemplateType.ShoppingCartOrderConfirmation, this.webTrackUser.webTrackInstanceID).subscribe(emailTemplateResult => {
    //     emailTemplate = emailTemplateResult;
    //     this.sendMail();
    //     subscribe(true);
    //   });
    // }
    // else if (transactionType == CheckoutParametersTransactionType.Quote) {
    //   this.client.getEmailTemplate(EmailTemplateType.ShoppingCartQuoteConfirmation, this.webTrackUser.webTrackInstanceID).subscribe(emailTemplateResult => {
    //     emailTemplate = emailTemplateResult;
    //     this.sendMail();
    //     subscribe(true);
    //   });
    // }
  }

  getEmailTemplate(subscribe: (emailTemplate: any) => void) {
    let emailTemplate: EmailTemplate;
    let email: string;

    if (this.quickOrderService.quickOrder && this.quickOrderService.quickOrder.contact) {
      if (this.quickOrderService.quickOrder.contact.email) {
        email = this.quickOrderService.quickOrder.contact.email;
      } else if (this.quickOrderService.quickOrder.customer.email) {
        email = this.quickOrderService.quickOrder.customer.email;
      } else {
        email = 'Order customer e-mail is not valid!';
      }
    } else {
      if (this.quickOrderService.quickOrder.customer.email) {
        email = this.quickOrderService.quickOrder.customer.email;
      } else {
        email = 'Order customer e-mail is not valid!';
      }
    }

    let mailParameters: PaymentRequestEmailParameters;

    this.createPaymentRequestParameters(email, (paymentRequestEmailParameters: any) => {
      mailParameters = paymentRequestEmailParameters;
      let templateID = 0;
      let userOptions: UserOption[];
      // Get default template ID for payment link e-mail
      this.client.getUserOptions(this.webTrackUser.bisTrackUserId).subscribe(result => {
        userOptions = result;
        const templateIDOption = userOptions.find(x => x.userID == this.webTrackUser.bisTrackUserId &&
          x.optionType == UserOptionOptionType.UotMyOptionsSettings && x.optionKey == UserOptionsID.uoidEmailTemplatePaymentURL.toString());
        if (templateIDOption && templateIDOption.optionValue) {
          templateID = Number(templateIDOption.optionValue);
          this.getEmailTemplateByID(templateID, (emailTemplate: any) => {
            emailTemplate = emailTemplate;
            subscribe(this.updateEmailTemplate(emailTemplate, mailParameters));
          });
        } else {
          this.client.getTemplatesByTypeID(Number(ContentServiceEmailTemplateType.PaymentRequestNotification_BT)).subscribe(allPaymentLinkTemplates => {
            if (allPaymentLinkTemplates && allPaymentLinkTemplates.length > 0) {
              templateID = allPaymentLinkTemplates[0].emailTemplateId;
            }

            this.getEmailTemplateByID(templateID, (emailTemplate: any) => {
              emailTemplate = emailTemplate;
              subscribe(this.updateEmailTemplate(emailTemplate, mailParameters));
            });
          });
        }
      });
    });
  }

  getEmailTemplateByID(templateID, subscribe: (result: any) => void) {
    if (templateID > 0) {
      this.client.getEmailTemplateByID(templateID).subscribe(result => {
        subscribe(result);
      });
    } else {
      subscribe(null);
    }
  }

  createPaymentRequestParameters(email: string, subscribe: (result: PaymentRequestEmailParameters) => void) {
    const parameters: PaymentRequestEmailParameters = new PaymentRequestEmailParameters();
    this.client.encryptOrderID(this.quickOrderService.quickOrder.OrderID).subscribe(result => {
      parameters.paymentURL = '/Payment.aspx?PaymentForOrderID=' + result; // + HttpUtility.UrlEncode(CryptoHelper.EncryptOrderID(this.quickOrderService.quickOrder.OrderID));
      parameters.reference = this.quickOrderService.quickOrder.customerRef;
      parameters.companyName = this.quickOrderService.quickOrder.customer.name;
      parameters.branchName = this.quickOrderService.quickOrder.branch.name;
      parameters.mailFromAddress = this.getTransactionNotificationFromAddress(); // Sess.Current.CurrentUser.GetTransactionNotificationFromAddress(Sess.Current.BisTrackSettings);
      parameters.mailToAddress = email;
      subscribe(parameters);
    });
  }

  getTransactionNotificationFromAddress(): string {
    if (this.webTrackUser.supportEmailAddress) {
      return this.webTrackUser.supportEmailAddress;
    }
    return this.bisTrackSettings.emailAcknowledgementFrom;
  }

  getEmailTo(): string {
    if (this.quickOrderService.quickOrder && this.quickOrderService.quickOrder.contact && this.quickOrderService.quickOrder.contact.email) {
      return this.quickOrderService.quickOrder.contact.email;
    } else if (this.quickOrderService.quickOrder && this.quickOrderService.quickOrder.customer) {
      return this.quickOrderService.quickOrder.customer.email;
    } else {
      return '';
    }
  }

  getBody() {
    if (this.emailTemplate && this.emailTemplate.body) {
      return this.emailTemplate.body;
    } else {
      // Need to return default body
      return '';
    }
  }

  updateEmailTemplate(emailTemplate: EmailTemplate, mailParameters: PaymentRequestEmailParameters): EmailTemplate {
    const re = /<%/gi;
    const re1 = /%>/gi;
    // emailTemplate.body = emailTemplate.body.replace(re,'%');
    // emailTemplate.body = emailTemplate.body.replace(re1,'%');
    emailTemplate.body = emailTemplate.body.replace(/%PaymentURL%/gi, mailParameters.paymentURL);
    emailTemplate.body = emailTemplate.body.replace(/%Company%/gi, this.bisTrackSettings.companyName);
    emailTemplate.body = emailTemplate.body.replace(/%Branch%/gi, this.quickOrderService.quickOrder.branch.name);

    if (this.quickOrderService.quickOrder.customerRef) {
      emailTemplate.body = emailTemplate.body.replace(/%Reference%/gi, this.quickOrderService.quickOrder.customerRef);
      emailTemplate.subject = emailTemplate.subject.replace(/%Reference%/gi, this.quickOrderService.quickOrder.customerRef);
    } else {
      emailTemplate.body = emailTemplate.body.replace(/%Reference%/gi, '%Transaction%');
      emailTemplate.subject = emailTemplate.subject.replace(/%Reference%/gi, '%Transaction%');
    }

    emailTemplate.body = emailTemplate.body.replace(/%Transaction%/gi, 'Sales Order Number ' + this.quickOrderService.quickOrder.OrderNumber + ' ');
    emailTemplate.subject = emailTemplate.subject.replace(/%Transaction%/gi, 'Sales Order Number ' + this.quickOrderService.quickOrder.OrderNumber + ' ');
    emailTemplate.subject = emailTemplate.subject.replace(/%Branch%/gi, this.quickOrderService.quickOrder.branch.name);
    emailTemplate.subject = emailTemplate.subject.replace(/%Company%/gi, this.bisTrackSettings.companyName);
    emailTemplate.subject = 'BisTrack Cloud: ' + emailTemplate.subject;

    return emailTemplate;
  }

  sendPaymentRequest(toEmail: string, emailTemplate: EmailTemplate, messageStatus: ReportServerQueueItemStatus, subscribe: (result: any) => void) {
    let mailParameters: PaymentRequestEmailParameters;
    this.createPaymentRequestParameters(toEmail, (paymentRequestEmailParameters: any) => {
      mailParameters = paymentRequestEmailParameters;
      let defaultComputer: Computer;
      let reportParameters: ReportParameters;
      this.client.getComputer(1).subscribe(computerResult => {
        defaultComputer = computerResult;
        this.createReportParameters(mailParameters, emailTemplate, defaultComputer, (reportParameters: any) => {
          reportParameters = reportParameters;
          const queueItem: ReportServerQueueItem = new ReportServerQueueItem();
          queueItem.userID = this.webTrackUser.bisTrackUserId;
          queueItem.computerID = defaultComputer.computerID;
          queueItem.type = ReportServerQueueItemType.Rs2tDocument;
          queueItem.status = messageStatus;
          queueItem.reportServerName = defaultComputer.reportServerName;
          queueItem.documentType = ReportServerQueueItemDocumentType.DtSalesOrder;
          queueItem.formatNumber = 1;
          queueItem.dateTimeSubmitted = new Date();
          queueItem.printDestination = '';
          queueItem.reportParameters = reportParameters;
          queueItem.templateID = emailTemplate.emailTemplateId;

          try {
            this.client.addItemToReportServerQueue(queueItem).subscribe(result => {
              if (!result) {
                subscribe(SendPaymentLinkResult.CanNotAddItemToReportServerQueue);
              } else {
                subscribe(SendPaymentLinkResult.Success);
              }
            });
          } catch (ex) {
            subscribe(SendPaymentLinkResult.CanNotAddItemToReportServerQueue);
          }
        });
      });
    });
  }

  createReportParameters(mailParameters: PaymentRequestEmailParameters, emailTemplate: EmailTemplate, defaultComputer: Computer, subscribe: (reportParameters: ReportParameters) => void) {
    const reportParameters: ReportParameters = new ReportParameters();
    reportParameters.reportSelectionFormula = '{OrderHeader.OrderID} IN [' + this.quickOrderService.quickOrder.OrderID + ']';
    reportParameters.orderID = this.quickOrderService.quickOrder.OrderID;
    reportParameters.reportType = ReportParametersReportType.Rs2tDocument;
    reportParameters.documentType = ReportParametersDocumentType.DtSalesOrder;
    reportParameters.documentFormatNumber = 1;
    this.client.getReportName(DocumentType2.Order).subscribe(documentNameWithPath => {
      var documentNameWithPath = documentNameWithPath;
      const splitted: string[] = documentNameWithPath.split('\\');
      reportParameters.documentFileName = splitted[splitted.length - 1];
      reportParameters.printerName = '';
      reportParameters.reportServerName = defaultComputer.reportServerName;
      reportParameters.paperOrientation = 1;
      reportParameters.paperBin = -1;
      reportParameters.numberOfCopies = 1;
      reportParameters.faxHeader = '';
      reportParameters.faxFooter = '';
      reportParameters.reprint = false;
      reportParameters.watermark = ''; // TODO replace it with value from Document control
      reportParameters.imagePDF = false;
      reportParameters.emailPDF = true;
      reportParameters.emailFrom = mailParameters.mailFromAddress;
      reportParameters.emailTo = mailParameters.mailToAddress;
      reportParameters.emailCC = '';
      reportParameters.emailBCC = '';
      reportParameters.emailSubject = emailTemplate.subject;
      reportParameters.emailMessage = emailTemplate.body;
      reportParameters.emailMessageRTF = '';
      reportParameters.emailAttachments = '';
      reportParameters.sendToFileName = 'Sales Order ' + this.quickOrderService.quickOrder.OrderNumber + '.pdf';
      reportParameters.faxPDF = false;
      reportParameters.faxTo = '';
      reportParameters.faxSubject = '';
      reportParameters.faxMessage = '';
      reportParameters.emailTemplateID = 0;
      reportParameters.branchName = ''; // this.order.Branch.Name;
      reportParameters.transactionName = '';

      subscribe(reportParameters);
    });
  }

  getSendLinkResultDescription(sendPaymentLinkResult: SendPaymentLinkResult) {
    let description = '';
    switch (sendPaymentLinkResult) {
      case SendPaymentLinkResult.Success:
        description = 'Payment Link message submitted to Report Server queue.';
        break;
      case SendPaymentLinkResult.TemplateNotFound:
        description = 'Payment link template not found or has not been set in user options. Please contact your BisTrack administrator';
        break;
      case SendPaymentLinkResult.CanNotAddItemToReportServerQueue:
        description = "Error: Can't add item to Report Server queue";
        break;
      case SendPaymentLinkResult.UnhandledException:
        description = 'Error: Unhandled exception';
        break;
      case SendPaymentLinkResult.ValidEmailAddressIsRequired:
        description = 'Valid contact or customer e-mail address is required!';
        break;
      default:
        description = 'Unhandled error';
        break;
    }
    return description;
  }

  // Payment Start

  geti4goTrueTokenParameters(subscribe: (i4goTrueTokenParameters: I4goTrueTokenParamsResponse) => void) {
    this.client.i4goTrueTokenParameters(this.bisTrackSettings).subscribe(i4goTrueTokenParameters => {
      this.i4goTrueTokenParameters = i4goTrueTokenParameters;
      subscribe(this.i4goTrueTokenParameters);
    });
  }


  paymentComplete(subscribe: (status: boolean) => void) {
    let param;
    if (this.isQuickOrder) {
      param = localStorage.getItem('QuickOrder');
    } else {
      param = localStorage.getItem('Order');
    }

    let payment;
    if (param) {
      payment = JSON.parse(param);
      const item1 = payment['i4go_response'];
      // this.quickOrderService.quickOrder.i4GoReturnParameters = new EpbtFaReturnParametersModel(payment);
      this.waitFlag = false;
      this.successFlag = false;
      this.errorFlag = false;

      if (this.quickOrderService.quickOrder.i4GoReturnParameters) {
        // InitializeProcessingView

        if (this.quickOrderService.quickOrder.i4GoReturnParameters.responseCode == ResponseCode.Aborted) {
          this.clearSessionPaymentParameters();
          this.setViewsVisible(true, false, false, false, false, false, false);
          subscribe(false);
          return;
        }

        if (!this.quickOrderService.quickOrder.i4GoReturnParameters.success) {
          this.setViewsVisible(false, false, false, false, true, false, false);
          this.quickOrderService.errorMessage = 'An error occurred processing your payment. Your card has NOT been charged.';
          subscribe(false);
          return;
        }

        // Add up to 4 product description lines to the parameters to send.

        const shift4WebTrackPaymentToken = new Shift4WebTrackPaymentToken();
        shift4WebTrackPaymentToken.i4go_response = this.quickOrderService.quickOrder.i4GoReturnParameters.response;
        shift4WebTrackPaymentToken.i4go_responsecode = this.quickOrderService.quickOrder.i4GoReturnParameters.responseCode;
        shift4WebTrackPaymentToken.i4go_responsetext = this.quickOrderService.quickOrder.i4GoReturnParameters.responseText;
        shift4WebTrackPaymentToken.i4go_cardtype = this.quickOrderService.quickOrder.i4GoReturnParameters.cardType;
        shift4WebTrackPaymentToken.i4go_maskedcard = this.quickOrderService.quickOrder.i4GoReturnParameters.maskedCard;
        shift4WebTrackPaymentToken.i4go_uniqueid = this.quickOrderService.quickOrder.i4GoReturnParameters.uniqueId;
        shift4WebTrackPaymentToken.i4go_expirationmonth = this.quickOrderService.quickOrder.i4GoReturnParameters.expirationMonth;
        shift4WebTrackPaymentToken.i4go_expirationyear = this.quickOrderService.quickOrder.i4GoReturnParameters.expirationYear;
        shift4WebTrackPaymentToken.useAVS = true;
        shift4WebTrackPaymentToken.avsCardholdeName = this.cardHolderName; // this.quickOrderService.quickOrder.i4GoReturnParameters.avsCardholdeName;
        shift4WebTrackPaymentToken.avsStreetAddress = this.streetAddress; // this.quickOrderService.quickOrder.i4GoReturnParameters.avsStreetAddress;
        shift4WebTrackPaymentToken.avsPostalCode = this.postalCode; // this.quickOrderService.quickOrder.i4GoReturnParameters.avsPostalCode;
        if (this.isQuickOrder) {
          shift4WebTrackPaymentToken.amount = this.quickOrderService.quickOrder.TotalAmount; // PaymentAmount
          shift4WebTrackPaymentToken.taxAmount = this.quickOrderService.quickOrder.TotalTax;
        } else {
          shift4WebTrackPaymentToken.amount = this.orderTotalAmount; // PaymentAmount
          shift4WebTrackPaymentToken.taxAmount = this.orderTotalTax;
        }
        shift4WebTrackPaymentToken.productCodes = [];
        let count = 0;
        if (this.isQuickOrder) {
          this.quickOrderService.quickOrder.Lines.forEach(line => {
            count++;
            if (count <= 4) {
              shift4WebTrackPaymentToken.productCodes.push(line.Product.productCode);
            }
          });
        } else {
          shift4WebTrackPaymentToken.productCodes.push(this.selectedOrder.orderNumber.toString());
        }
        this.client.shift4WebTrackPaymentToken(shift4WebTrackPaymentToken).subscribe(webTrackPaymentToken => {
          this.quickOrderService.quickOrder.PaymentToken = webTrackPaymentToken;
          if (!this.quickOrderService.quickOrder.PaymentToken || this.quickOrderService.quickOrder.PaymentToken.amount == 0 ||
            this.quickOrderService.quickOrder.PaymentToken.paymentProvider != WebTrackPaymentTokenPaymentProvider.Shift4) {
            this.clearSessionPaymentParameters();
            this.setViewsVisible(false, false, false, false, true, false, false);
            this.quickOrderService.errorMessage = 'An error occurred while processing your payment. Your card has not been charged.';
            //       this.GenericErrorMessageLiteral.Text = Resources.Resources.PaymentCard_Error_GenericFailure;
            subscribe(false);
            return;
          }

          let result: WebServiceCallResult;

          if (this.isQuickOrder) {
            try {
              this.quickOrderService.quickOrder.AttemptedQuickOrderPayment = true;
              if (this.quickOrderService.quickOrder.selectedSalesType == SaleType.CollectNow) {
                const salesOrder: Order = new Order();
                salesOrder.orderId = this.quickOrderService.quickOrder.OrderID;
                const paymentOnOrderRequest: MakePaymentOnOrderRequest = new MakePaymentOnOrderRequest();
                paymentOnOrderRequest.user = this.webTrackUser;
                paymentOnOrderRequest.user.customer = this.quickOrderService.quickOrder.customer;
                paymentOnOrderRequest.paymentToken = this.quickOrderService.quickOrder.PaymentToken;
                paymentOnOrderRequest.accountPaymentToken = null;
                paymentOnOrderRequest.salesOrder = salesOrder;
                this.client.makePaymentOnOrder(paymentOnOrderRequest).subscribe(result => {
                  this.afterPayment(result, (status: boolean) => {
                    if (status) {
                      subscribe(true);
                      this.successFlag = true;
                    } else {
                      subscribe(false);
                      this.errorFlag = true;
                    }
                  });
                });
              } else {
                const preauthorizedPaymentRequest: MakePreauthorizedPaymentRequest = new MakePreauthorizedPaymentRequest();
                preauthorizedPaymentRequest.user = this.webTrackUser;
                // paymentOnOrderRequest.user.customer = this.quickOrderService.quickOrder.customer;
                preauthorizedPaymentRequest.paymentToken = this.quickOrderService.quickOrder.PaymentToken;

                this.client.makePreauthorizedPayment(preauthorizedPaymentRequest).subscribe(result => {
                  this.afterPayment(result, (status: boolean) => {
                    if (status) {
                      subscribe(true);
                      this.successFlag = true;
                    } else {
                      subscribe(false);
                      this.errorFlag = true;
                    }
                  });
                });
              }
            } catch (ex) {
              // log4net.LogManager.GetLogger(this.GetType()).Fatal(xn);
              // result = new WebServiceCallResult<WebTrackPaymentResult, PaymentFailure>(new PaymentFailure(xn.Message));
            }
          } else {
            try {
              this.quickOrderService.quickOrder.AttemptedQuickOrderPayment = true;
              const paymentOnOrderRequest: MakePaymentOnOrderRequest = new MakePaymentOnOrderRequest();
              paymentOnOrderRequest.user = this.webTrackUser;
              paymentOnOrderRequest.user.customer = this.quickOrderService.quickOrder.customer;
              paymentOnOrderRequest.paymentToken = this.quickOrderService.quickOrder.PaymentToken;
              paymentOnOrderRequest.accountPaymentToken = null;
              paymentOnOrderRequest.salesOrder = this.selectedOrder;
              paymentOnOrderRequest.salesOrder.dateRequested = paymentOnOrderRequest.salesOrder.dateRequired;
              if (this.bisTrackSettings.allowCashOnDeliveries && this.selectedOrder.cashSale &&
                this.selectedOrder.invoiced == false && this.selectedOrder.cashOnDeliveryAmountInCurrency - this.selectedOrder.calculatedCODTotalInCurrencyReceived > 0) {
                paymentOnOrderRequest.codPayment = true;
              } else {
                paymentOnOrderRequest.codPayment = false;
              }
              paymentOnOrderRequest.cashAccountBalanceAdjustment = false;

              this.client.makePaymentOnOrder(paymentOnOrderRequest).subscribe(result => {
                this.afterPayment(result, (status: boolean) => {
                  if (status) {
                    subscribe(true);
                    this.successFlag = true;
                  } else {
                    subscribe(false);
                    this.errorFlag = true;
                  }
                });
              });
            } catch (ex) {
              // log4net.LogManager.GetLogger(this.GetType()).Fatal(xn);
              // result = new WebServiceCallResult<WebTrackPaymentResult, PaymentFailure>(new PaymentFailure(xn.Message));
            }
          }



          this.quickOrderService.quickOrder.PaymentResult = result.result;
        });
      } else {
        // Yet to write the code for this.
      }
    }
  }

  paymentCompleteForEpa(subscribe: (status: boolean) => void) {
    let param;
    if (this.isQuickOrder) {
      param = localStorage.getItem('QuickOrder');
    } else {
      param = localStorage.getItem('Order');
    }

    if (param) {
      // this.waitFlag = false;
      this.successFlag = false;
      this.errorFlag = false;

      if (this.quickOrderService.quickOrder.epaReturnParameters) {
        // InitializeProcessingView

        if (!this.quickOrderService.quickOrder.epaReturnParameters.success) {
          this.setViewsVisible(false, false, false, false, true, false, false);
          this.quickOrderService.errorMessage = 'Could not connect to payment application. Please check payment application address system option.';
          subscribe(false);
          return;
        }

        const epicorPaymentCheckAVSRequest = new EpicorPaymentCheckAVSRequest();
        epicorPaymentCheckAVSRequest.webTrackInstanceId = this.bisTrackSettings.webTrackInstanceID;
        epicorPaymentCheckAVSRequest.user = this.webTrackUser;

        epicorPaymentCheckAVSRequest.creAvsRequest = new CreAvsRequest();
        epicorPaymentCheckAVSRequest.creAvsRequest.billingAddress = this.quickOrderService.quickOrder.epaReturnParameters.billingAddress;
        epicorPaymentCheckAVSRequest.creAvsRequest.cardOnFileId = 0;
        epicorPaymentCheckAVSRequest.creAvsRequest.expDate = this.quickOrderService.quickOrder.epaReturnParameters.expdate;
        epicorPaymentCheckAVSRequest.creAvsRequest.isCardOnFile = false;
        epicorPaymentCheckAVSRequest.creAvsRequest.postalCode = this.quickOrderService.quickOrder.epaReturnParameters.postalCode;
        epicorPaymentCheckAVSRequest.creAvsRequest.token = this.quickOrderService.quickOrder.epaReturnParameters.token;

        this.client.checkAVS(epicorPaymentCheckAVSRequest).subscribe(result => {
          if (!result && result.avsSuccess) {
            this.waitFlag = false;
            this.createTokenAndPaymentForEPA((status: boolean) => {
              subscribe(status);
            });
          } else {
            EpDialogService.custom({
              title: 'AVS Confirmation',
              message: "The provided address and/or postal code does not match cardholder's address: " + result.avsDescription,
              description: "Do you still want to continue with the transaction?",
              buttons: EpDialogButtons.YesNo
            }).promise.then((result: IEpDialogResult) => {
              if (result.action.text.toUpperCase() == 'YES') {
                this.waitFlag = false;
                this.createTokenAndPaymentForEPA((status: boolean) => {
                  subscribe(status);
                });
              } else {
                this.waitFlag = true;
                this.cardVerificationFlag = false;
              }
            });
          }
        },
          err => {
            console.log('Subscribe Error = ', err);
          }
        );
      } else {
        // Yet to write the code for this.
      }
    }
  }

  createTokenAndPaymentForEPA(subscribe: (status: boolean) => void) {
    // this.waitFlag = false;
    const epicorPaymentTokenRequest = new EpicorPaymentTokenRequest();
    epicorPaymentTokenRequest.branch = this.quickOrderService.quickOrder.branch;
    epicorPaymentTokenRequest.customer = this.quickOrderService.quickOrder.customer;
    epicorPaymentTokenRequest.customerCard = new CustomerCard();
    epicorPaymentTokenRequest.customerCard.billingAddress = this.quickOrderService.quickOrder.epaReturnParameters.billingAddress;
    epicorPaymentTokenRequest.customerCard.cardExpiryDate = new Date(this.quickOrderService.quickOrder.epaReturnParameters.expdate);
    epicorPaymentTokenRequest.customerCard.cardToken = this.quickOrderService.quickOrder.epaReturnParameters.token;
    epicorPaymentTokenRequest.customerCard.zipCode = this.quickOrderService.quickOrder.epaReturnParameters.postalCode;
    epicorPaymentTokenRequest.emailAddresses = '';
    epicorPaymentTokenRequest.isCashAccountBalanceAdjustment = false;
    if (this.isQuickOrder) {
      epicorPaymentTokenRequest.paymentAmount = this.quickOrderService.quickOrder.TotalAmount; // PaymentAmount
      epicorPaymentTokenRequest.totalTax = this.quickOrderService.quickOrder.TotalTax;
    } else {
      epicorPaymentTokenRequest.paymentAmount = this.orderTotalAmount; // PaymentAmount
      epicorPaymentTokenRequest.totalTax = this.orderTotalTax;
    }

    epicorPaymentTokenRequest.user = this.webTrackUser;
    epicorPaymentTokenRequest.webTrackInstanceId = this.bisTrackSettings.webTrackInstanceID;
    this.client.createToken(epicorPaymentTokenRequest).subscribe(webTrackPaymentToken => {
      console.log(webTrackPaymentToken);
      this.quickOrderService.quickOrder.PaymentToken = webTrackPaymentToken;
      if (!this.quickOrderService.quickOrder.PaymentToken || this.quickOrderService.quickOrder.PaymentToken.amount == 0) {
        this.clearSessionPaymentParameters();
        this.setViewsVisible(false, false, false, false, true, false, false);
        this.quickOrderService.errorMessage = 'Could not connect to payment application. Please check payment application address system option.';
        subscribe(false);
        return;
      }

      let result: WebServiceCallResult;

      if (this.isQuickOrder) {
        try {
          this.quickOrderService.quickOrder.AttemptedQuickOrderPayment = true;
          if (this.quickOrderService.quickOrder.selectedSalesType == SaleType.CollectNow) {
            const salesOrder: Order = new Order();
            salesOrder.orderId = this.quickOrderService.quickOrder.OrderID;
            const paymentOnOrderRequest: MakePaymentOnOrderRequest = new MakePaymentOnOrderRequest();
            paymentOnOrderRequest.user = this.webTrackUser;
            paymentOnOrderRequest.user.customer = this.quickOrderService.quickOrder.customer;
            paymentOnOrderRequest.paymentToken = this.quickOrderService.quickOrder.PaymentToken;
            paymentOnOrderRequest.accountPaymentToken = null;
            paymentOnOrderRequest.salesOrder = salesOrder;
            this.client.makePaymentOnOrder(paymentOnOrderRequest).subscribe(result => {
              this.afterPayment(result, (status: boolean) => {
                if (status) {
                  subscribe(true);
                  this.successFlag = true;
                } else {
                  subscribe(false);
                  this.errorFlag = true;
                }
              });
            });
          } else {
            const preauthorizedPaymentRequest: MakePreauthorizedPaymentRequest = new MakePreauthorizedPaymentRequest();
            preauthorizedPaymentRequest.user = this.webTrackUser;
            // paymentOnOrderRequest.user.customer = this.quickOrderService.quickOrder.customer;
            preauthorizedPaymentRequest.paymentToken = this.quickOrderService.quickOrder.PaymentToken;

            this.client.makePreauthorizedPayment(preauthorizedPaymentRequest).subscribe(result => {
              this.afterPayment(result, (status: boolean) => {
                if (status) {
                  subscribe(true);
                  this.successFlag = true;
                } else {
                  subscribe(false);
                  this.errorFlag = true;
                }
              });
            });
          }
        } catch (ex) {
          // log4net.LogManager.GetLogger(this.GetType()).Fatal(xn);
          // result = new WebServiceCallResult<WebTrackPaymentResult, PaymentFailure>(new PaymentFailure(xn.Message));
        }
      } else {
        try {
          this.quickOrderService.quickOrder.AttemptedQuickOrderPayment = true;
          const paymentOnOrderRequest: MakePaymentOnOrderRequest = new MakePaymentOnOrderRequest();
          paymentOnOrderRequest.user = this.webTrackUser;
          paymentOnOrderRequest.user.customer = this.quickOrderService.quickOrder.customer;
          paymentOnOrderRequest.paymentToken = this.quickOrderService.quickOrder.PaymentToken;
          paymentOnOrderRequest.accountPaymentToken = null;
          paymentOnOrderRequest.salesOrder = this.selectedOrder;
          paymentOnOrderRequest.salesOrder.dateRequested = paymentOnOrderRequest.salesOrder.dateRequired;
          if (this.bisTrackSettings.allowCashOnDeliveries && this.selectedOrder.cashSale &&
            this.selectedOrder.invoiced == false && this.selectedOrder.cashOnDeliveryAmountInCurrency - this.selectedOrder.calculatedCODTotalInCurrencyReceived > 0) {
            paymentOnOrderRequest.codPayment = true;
          } else {
            paymentOnOrderRequest.codPayment = false;
          }
          paymentOnOrderRequest.cashAccountBalanceAdjustment = false;

          this.client.makePaymentOnOrder(paymentOnOrderRequest).subscribe(result => {
            this.afterPayment(result, (status: boolean) => {
              if (status) {
                subscribe(true);
                this.successFlag = true;
              } else {
                subscribe(false);
                this.errorFlag = true;
              }
            });
          });
        } catch (ex) {
          // log4net.LogManager.GetLogger(this.GetType()).Fatal(xn);
          // result = new WebServiceCallResult<WebTrackPaymentResult, PaymentFailure>(new PaymentFailure(xn.Message));
        }
      }

      this.quickOrderService.quickOrder.PaymentResult = result.result;
    });
  }

  afterPayment(result: WebSvcCallResult_WebTrackPaymentResult_PaymentFailure, subscribe: (status: boolean) => void) {
    if (result.failed) {
      this.clearSessionPaymentParameters();
      this.setViewsVisible(false, false, false, false, true, false, false);

      switch (result.error.reasonCode) {
        case PaymentFailureReasonCode.Declined:
        case PaymentFailureReasonCode.VoiceReferral:
          this.quickOrderService.errorMessage = 'The transaction was not approved by the payment processor. Your card has not been charged.';
          break;
        default:
          {
            if (this.quickOrderService.creCardEntryView) {
              this.quickOrderService.errorMessage = 'Could not connect to payment application. Please check payment application address system option.';
            } else {
              this.quickOrderService.errorMessage = 'An error occurred while processing your payment. Your card has not been charged.';
            }
          }
          break;
      }
      subscribe(false);
    } else {

      if (this.isQuickOrder) {

        this.generateWebTrackOrder((webtrackResult: CheckoutResults) => {
          if (webtrackResult.success) {
            this.setViewsVisible(false, false, false, false, false, true, false);
            console.log('webtrackResult.success = Success');
            // Initialize the success screen.
            this.setSuccessValues(result);
            subscribe(true);
          } else {
            this.setViewsVisible(false, false, false, false, true, false, false);
            const voidPaymentRequest = new VoidPaymentRequest();
            voidPaymentRequest.user = this.webTrackUser;
            voidPaymentRequest.paymentResult = result.result;
            this.client.voidPayment(voidPaymentRequest).subscribe(voidResult => {
              if (voidResult) {
                this.quickOrderService.errorMessage = 'Payment voided';
              } else {
                this.quickOrderService.errorMessage = 'Payment not voided';
              }
            });

            console.log('webtrackResult.Error');
            // Void the payment
            // if (ServiceLocator.Instance.BisTrackServices.AccountService.VoidPayment(Sess.Current.CurrentUser, result.Result))
            // {
            //     this.OrderCompletionErrorLabel2.InnerText = Resources.Resources.QuickOrder_PaymentVoided;
            // }
            // else
            // {
            //     this.OrderCompletionErrorLabel2.InnerText = Resources.Resources.QuickOrder_PaymentNotVoided;
            // }
            // this.Master.SetButtonsVisible(false, false, false, true, false);
            // this.SummaryPageMultiView.SetActiveView(this.OrderCompletionErrorView);

            subscribe(false);
          }
        });
      } else {
        this.setViewsVisible(false, false, false, false, false, true, false);
        this.setSuccessValues(result);
        subscribe(true);
      }
    }
    this.cardVerificationFlag = false;
  }

  setViewsVisible(summaryView: boolean = false, emailView: boolean = false, shift4EnterAVSView: boolean = false,
    shift4EnterCardDetailsView: boolean = false, i4GoErrorView: boolean = false, successView: boolean = false, creCardEntryView: boolean) {
    this.quickOrderService.summaryView = summaryView;
    this.quickOrderService.emailView = emailView;
    this.quickOrderService.shift4EnterAVSView = shift4EnterAVSView;
    this.quickOrderService.shift4EnterCardDetailsView = shift4EnterCardDetailsView;
    this.quickOrderService.i4GoErrorView = i4GoErrorView;
    this.quickOrderService.successView = successView;
    this.quickOrderService.creCardEntryView = creCardEntryView;
  }

  setSuccessValues(webtrackResult: WebSvcCallResult_WebTrackPaymentResult_PaymentFailure) {
    if (this.isQuickOrder) {
      this.successMessageLiteral = this.quickOrderService.quickOrder.selectedSalesType == 1 ? 'Payment was successful.' : 'Pre-authorization was successful.';
    } else {
      this.successMessageLiteral = 'Payment was successful.';
    }
    this.successTimestampLiteral = webtrackResult.result.timestamp.toString();
    this.successAmountLiteral = webtrackResult.result.amount;
    this.successCardNumber = webtrackResult.result.cardNumber;
    this.successCardType = webtrackResult.result.cardName;
    this.successConfirmationCode = webtrackResult.result.authorizationCode;
    this.successTransactionId = webtrackResult.result.webTrackInvoiceId.toString();
  }

  showErrorView(errorMessage?: string) {
    if (!errorMessage)
      errorMessage = "An error occurred while processing your payment. Your card has not been charged.";

    if (!this.quickOrderService.creCardEntryView) {
      this.setViewsVisible(false, false, false, false, true, false, false);
      this.cardVerificationFlag = false;
      this.quickOrderService.errorMessage = errorMessage;
      this.quickOrderService.quickOrder.i4GoReturnParameters = null;
    }
    else if (this.quickOrderService.creCardEntryView) {
      this.setViewsVisible(false, false, false, false, true, false, false);
      this.cardVerificationFlag = false;
      this.quickOrderService.errorMessage = errorMessage;//this.quickOrderService.quickOrder.i4GoReturnParameters.responseText;
      this.quickOrderService.quickOrder.epaReturnParameters = null;
    }
  }

  clearSuccessValues() {
    this.successMessageLiteral = '';
    this.successTimestampLiteral = '';
    this.successAmountLiteral = 0;
    this.successCardNumber = '';
    this.successCardType = '';
    this.successConfirmationCode = '';
    this.successTransactionId = '';
  }

  clearSessionPaymentParameters() {
    this.quickOrderService.quickOrder.PaymentToken = null;
    this.quickOrderService.quickOrder.PaymentResult = null;
    this.quickOrderService.quickOrder.PaymentAmount = null;
    this.quickOrderService.quickOrder.i4GoReturnParameters = null;
    this.quickOrderService.quickOrder.epaReturnParameters = null;
    this.quickOrderService.quickOrder.i4GoError = null;
    // Sess.Current.QuickOrder.I4GoError = null;
  }

  // Payment End
}
